import { 
  ROUTE_DELIVERY_ZONES_LIST,
  ROUTE_LOGISTIC_COURIERS,
  ROUTE_LOGISTIC_DASHBOARD, 
  ROUTE_LOGISTIC_SHIFTS_PLANNER, 
  ROUTE_LOGISTIC_SLOTS,
  ROUTE_LOGISTIC_VEHICLES, 
  ROUTE_PRODUCT_GROUPS 
} from '@@partner:config/routes'
import CommonTopMenu, { TopMenuElement } from '@components/common/CommonTopMenu'
import React from 'react'
import { CarSharp, CalendarOutline, CartOutline, LayersOutline, PeopleOutline, TimeOutline } from 'react-ionicons'


export default function LogisticTopMenu () {

  const elements: TopMenuElement[] = [
    {
      icon: <CartOutline />,
      to: ROUTE_LOGISTIC_DASHBOARD,
      title: 'Дашборд'
    },
    {
      icon: <LayersOutline />,
      to: ROUTE_DELIVERY_ZONES_LIST,
      title: 'Зоны доставки'
    },
    {
      icon: <TimeOutline />,
      to: ROUTE_LOGISTIC_SLOTS,
      title: 'Слоты доставки'
    },
    {
      icon: <PeopleOutline />,
      to: ROUTE_LOGISTIC_COURIERS,
      title: 'Курьеры'
    },
    {
      icon: <CalendarOutline/>,
      to: ROUTE_LOGISTIC_SHIFTS_PLANNER,
      title: 'Планировщик смен'
    },
    {
      icon: <CarSharp />,
      to: ROUTE_LOGISTIC_VEHICLES,
      title: 'Транспорт'
    }
  ]

  return <CommonTopMenu elements={elements} /> 
}